<template>
  <v-dialog v-model="googleIdDialog" :key="item._id" persistent max-width="400">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        icon
        :color="item.isGoogleId ? 'green' : 'grey lighten-1'"
      >
        <v-icon>mdi-google-maps</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-2 px-sm-6">
        <v-row class="pb-3" no-gutters>
          <v-col
            cols="8"
            lg="10"
            class="d-flex flex-column justify-center align-start py-0"
          >
            <h3 class="title text-start text-break">Google Maps ID</h3>
          </v-col>
          <v-col
            cols="4"
            lg="2"
            class="d-flex flex-column justify-center align-end py-0"
          >
            <v-btn icon color="grey lighten-1" @click="googleIdDialog = false">
              <v-icon class="dialog-close-icon">mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row
          class="mx-0"
          align="center"
          justify="center"
          justify-md="end"
          no-gutters
        >
          <v-col cols="12" class="px-0 py-0">
            <v-row class="mx-0" no-gutters>
              <span class="text-left secondary--text subtitle-1 mb-4"
                >Assign the Google Maps ID for <b>{{ item.formattedAddress }}</b
                >, by typing in the city name on the field below.</span
              >
            </v-row>
          </v-col>
          <v-col cols="12" class="px-0">
            <v-row class="mx-0" no-gutters>
              <v-text-field
                ref="autocomplete"
                v-model="cityName"
                label="Type the city name here"
                placeholder
                outlined
                @change="setLocation"
                :error-messages="errorCityName"
                @focus="errorCityName = null"
              ></v-text-field>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-row
          class="
            d-flex
            flex-column-reverse flex-sm-row
            align-center
            justify-space-between
            mx-0
          "
          no-gutters
        >
          <v-col
            cols="12"
            sm="4"
            class="d-flex flex-column align-center align-sm-start px-0"
          >
            <v-btn
              class="px-8 mx-0"
              color="secondary"
              @click="googleIdDialog = false"
              tile
              outlined
              depressed
              bottom
            >
              Cancel
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="d-flex flex-column align-center align-sm-end px-0"
          >
            <v-btn
              class="px-8 mx-0"
              @click="submitFn"
              color="secondary"
              tile
              depressed
              bottom
              right
            >
              Submit
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// config
import Config from "@/services/config";

// services
import cityServices from "@/services/city.service";

export default {
  name: "GoogleIDModal",
  props: {
    item: Object,
  },
  data() {
    return {
      googleIdDialog: false,
      search: "",
      cityName: null,
      long_name: null,
      short_name: null,
      placeId: null,
      googleMapURL: null,
      cityName4BackEnd: null,
      formattedAddress: null,
      lat: null,
      lng: null,
      googleAutocomplete: null,
      errorCityName: null,
      staticErrorMessages: {
        cityName: {
          isEmpty: "City name should not be empty",
          isInvalid: "Please select a valid city from the list",
        },
      },
    };
  },
  watch: {
    googleIdDialog(val) {
      if (val === true) {
        setTimeout(() => {
          this.checkAndAttachAutocompleteScript(() => {
            let element = this.$refs.autocomplete.$el;

            element = element.querySelector("input");
            const google = window.google;
            this.autocomplete = new google.maps.places.Autocomplete(element, {
              types: ["(cities)"],
            });
          });
        }, 500);
      }
    },
    cityName() {
      this.errorCountryName = null;
    },
  },
  methods: {
    checkAndAttachAutocompleteScript(callback) {
      let scriptId = "autocomplete-api-script";
      let scriptAlreadyAttached = !!document.getElementById(scriptId);
      if (scriptAlreadyAttached) {
        if (window.google)
          // Script attached but may not finished loading; so check for 'google' object.
          callback();
      } else {
        window.autocompleteApiInitialized = callback;
        const APIKEY = Config.gMapAPIKey;
        let script = document.createElement("script");
        script.id = scriptId;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${APIKEY}&libraries=places&language=en&callback=autocompleteApiInitialized&v=weekly`;
        document.body.appendChild(script);
      }
      return scriptAlreadyAttached;
    },
    setLocation() {
      this.autocomplete.addListener("place_changed", () => {
        let place = this.autocomplete.getPlace();
        let address_components = place.address_components.find((address) => {
          if (address.types.includes("country")) {
            return address;
          }
        });
        this.long_name = address_components.long_name;
        this.short_name = address_components.short_name;
        this.placeId = place.place_id;
        this.googleMapURL = place.url;
        this.cityName4BackEnd = place.vicinity;
        this.cityName = place.formatted_address;
        this.formattedAddress = place.formatted_address;
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
      });
    },
    submitFn() {
      if ((this.cityName, this.placeId)) {
        let payload = {
          _id: this.item._id,
          CityName: this.cityName4BackEnd,
          Coordinates: [this.lng, this.lat], //1st lng 2nd lat
          FormattedAddress: this.formattedAddress,
          GoogleMapURL: this.googleMapURL,
          GooglePlaceId: this.placeId,
          long_name: this.long_name,
          short_name: this.short_name,
        };

        cityServices.SetCityVerify(payload).then((res) => {
          if (res.data.success) {
            this.googleIdDialog = false;
            let payload2 = {
              snackBarText: `City Details Updated`,
              snackBarColor: "success",
            };
            this.$store.dispatch("notify/setSnackbarMessage", payload2);
            this.$emit("initFN");
          }
        });
        // this.$emit("setCity", payload);
      } else {
        this.errorCityName = this.staticErrorMessages.cityName.isEmpty;
      }
      if (!this.placeId) {
        this.errorCityName = this.staticErrorMessages.cityName.isEmpty;
      }
    },
  },
};
</script>
<style scoped>
.v-dialog .v-card .v-card__title .v-icon.dialog-close-icon {
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  width: 32px;
  height: 32px;
  font-size: 24px;
}
</style>